export default {
    HistoryListItem: {
        integrator: 'Integrador',
        admin: 'Painel'
    }
}